import ConsultaBase from "../shared/ConsultaBase";
import { optichiller2CompConsultaConfig } from "../config/optichiller2compConsulta";

const COptichiller2Comp = () => {
  return <ConsultaBase config={optichiller2CompConsultaConfig} />;
};

export default COptichiller2Comp; 

